import { useQueries } from '@tanstack/react-query';
import { FinancialItems } from 'src/financial/financial-data/hooks/useFinancialItems';
import {
  FinancialCategory,
  buildCategories,
  emptyGroupedRows,
  extractRows,
  mergeGroupedRows,
} from 'src/financial/financial-data/rework/financialRows';
import { FamilyMember } from './useFamilyMembers';

export function useFamilyFinancialItems(members: FamilyMember[]): {
  categories: FinancialCategory[];
  isLoading: boolean;
  hasErrors: boolean;
} {
  const results = useQueries({
    queries: members.map(member => ({
      queryKey: ['clients', member.clientId, 'financial-items-bff'],
      enabled: !!member.clientId,
    })),
  });

  const isLoading = results.some(result => result.isLoading);
  const hasErrors = results.some(result => result.isError);

  const grouped = members.map((member, index) => {
    const data = results[index].data as FinancialItems | undefined;
    if (!data) return emptyGroupedRows();
    return extractRows(data, member.client.firstName);
  });

  const categories = buildCategories(mergeGroupedRows(grouped));

  return { categories, isLoading, hasErrors };
}
